import axios from 'axios'
import { BASE_URL } from '../actions/global'
import * as rt from '../config/routeType'
import moment from 'moment'
import _ from 'lodash'

export const getAllLocations = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/${rt.FEATURE_LOCATION}`)
    if (response.status !== 200) return {}
    return {
      type: 'FeatureCollection',
      features: response.data.locations || [],
    }
  } catch (err) {
    console.log('Error: ', err)
  }
}

export const getAllDataByTreesFilters = async (type, filterlist, onlyIds = false) => {
  const queryList = _.includes(['pseudonym', 'site', 'sitetype', 'code'], type)
    ? _.map(filterlist, 'title')
    : _.map(filterlist, 'id')
  return axios({
    method: 'post',
    url: `${BASE_URL}/${rt.TREE}/${rt.GEOJSON_FILTERS}`,
    data: {
      type,
      queryList,
      onlyIds,
    },
  })
    .then(res => {
      return !onlyIds
        ? {
            type: 'FeatureCollection',
            features: res.data.response || [],
          }
        : res.data.response
    })
    .catch(error => {
      console.log('Error :>> ', error.response.data)
      return {}
    })
}

export const getTreeByFeaturesFilters = async queryList => {
  return axios({
    method: 'post',
    url: `${BASE_URL}/${rt.FEATURE}/${rt.GEOJSON_FILTERS}`,
    data: {
      queryList,
    },
  })
    .then(res => ({
      type: 'FeatureCollection',
      features: res.data.response || [],
    }))
    .catch(error => {
      console.log('Error :>> ', error.response.data)
      return {}
    })
}

export const getPropertiesByID = async treeId => {
  try {
    const response = await axios.get(`${BASE_URL}/${rt.FEATURE}/${treeId}`)
    if (response.status !== 200) return {}
    let properties = response.data.properties || {}

    const inconv_names = _.map(properties.inconveniences, 'name')
    const uniqCategorys = _.uniq(inconv_names)

    const inconvByCategory = uniqCategorys.map(catName => {
      let newObj = { id: null, category: catName, attributes: [] }

      properties.inconveniences.forEach(inconv_ => {
        let attributes = {}
        if (inconv_.name === catName) newObj.id = inconv_.id
        if (inconv_.name === catName) {
          attributes[`${inconv_.type.key}`] = {
            id: inconv_.type.id,
            label: inconv_.type.description,
            value: inconv_.type.value,
            date: inconv_.dateLog,
          }
          newObj.attributes.push(attributes)
        }
      })
      return newObj
    })
    properties.inconveniences = inconvByCategory
    return properties
  } catch (err) {
    console.log('Error: ', err)
  }
}

export const login = ({ email, password }) => {
  return axios({
    method: 'post',
    url: `${BASE_URL}/${rt.AUTH_LOGIN}`,
    data: {
      email: email,
      contrasena: password,
    },
  })
    .then(res => res.data)
    .catch(err => err.response.data)
}

function createOptionList(res, key, value) {
  let data = {}
  res.data?.res?.forEach(o => {
    let ObjNew = {}
    if (Boolean(o.habilitado?.data?.[0])) {
      ObjNew[`${o[key]}`] = o[value]
      data = { ...data, ...ObjNew }
    }
  })
  // if (Object.keys(data).length) data = _.sortedUniq(data)
  return data
}

export const getPseudonymAll = () => {
  return axios
    .get(`${BASE_URL}/${rt.PSEUDONYM}`)
    .then(res => {
      const { pseudonym } = res.data
      let response = []
      pseudonym?.forEach(obj => {
        if (Boolean(obj.habilitado.data[0]))
          response.push({ id: obj.id_ps, name: obj.nombre_comun })
      })
      const unique = _.uniqBy(response, 'name')
      const orderby = _.orderBy(unique, ['name'], ['asc'])
      return orderby
    })
    .catch(err => err.response.data)
}

export const getPseudonymsBySpecieId = specieId => {
  return axios
    .get(`${BASE_URL}/${rt.PSEUDONYM}/for-specie/${specieId}`)
    .then(res => {
      const { pseudonym } = res.data
      let response = []
      pseudonym?.forEach(obj => {
        if (Boolean(obj.habilitado.data[0]))
          response.push({ id: obj.id_ps, name: obj.nombre_comun })
      })
      const unique = _.uniqBy(response, 'name')
      const orderby = _.orderBy(unique, ['name'], ['asc'])
      return orderby
    })
    .catch(err => err.response.data)
}

export const getSitesDataByName = (siteName, field) => {
  return axios
    .get(`${BASE_URL}/${rt.SITE}/for-name/${siteName}`)
    .then(res => {
      const { sites } = res.data
      const options = sites?.map((site, index) => ({
        id: index,
        label: site[field],
      }))
      return options ?? []
    })
    .catch(err => err.response.data)
}

export const getFamilyAll = () => {
  return axios
    .get(`${BASE_URL}/${rt.FAMILY}`)
    .then(res => createOptionList(res, 'id_f', 'nombre'))
    .catch(err => err.response.data)
}

export const getFamilyTableAll = () => {
  return axios
    .get(`${BASE_URL}/${rt.FAMILY}`)
    .then(res => {
      return _.map(res.data.res, row => ({
        id: row.id_f,
        nombre: row.nombre,
        habilitado: Boolean(row.habilitado.data[0]),
      }))
    })
    .catch(err => err.response.data)
}

export const getOptionsfamily = () => {
  return getFamilyTableAll()
    .then(response => {
      const listElemEnable = _.filter(response, ['habilitado', true])
      const uniq = _.unionBy(listElemEnable, 'nombre')
      const sorted = _.orderBy(uniq, ['nombre'], ['asc'])
      return (
        sorted?.map(o => ({
          title: o.nombre,
          id: o.id,
        })) ?? []
      )
    })
    .catch(error => error)
}

export const updateFamilyTableById = (data, token, specieId) => {
  return axios({
    method: 'put',
    url: `${BASE_URL}/${rt.FAMILY}/${rt.UPDATE_FAMILY}/${specieId}`,
    data,
    headers: {
      Authorization: token,
    },
  })
    .then(response => response.data)
    .catch(err => err.response.data)
}

export const createFamily = (data, token) => {
  return axios({
    method: 'post',
    url: `${BASE_URL}/${rt.FAMILY}/${rt.REGISTER_FAMILY}`,
    data,
    headers: {
      Authorization: token,
    },
  })
    .then(response => response.data)
    .catch(err => err.response.data)
}

export const getSpecieAll = () => {
  return axios
    .get(`${BASE_URL}/${rt.SPECIE}`)
    .then(res => createOptionList(res, 'id_e', 'nombre_cientifico'))
    .catch(err => err.response.data)
}

export const getOptionsSpecies = () => {
  return getSpecieAll()
    .then(res => {
      return (
        _.map(Object.keys(res), key => ({
          title: res[key],
          id: parseInt(key, 10),
        })) ?? []
      )
    })
    .catch(error => error)
}

export const getSpecieTableAll = () => {
  return axios
    .get(`${BASE_URL}/${rt.SPECIE}`)
    .then(res => {
      return _.map(res.data.res, row => ({
        id: row.id_e,
        nombre_cientifico: row.nombre_cientifico,
        idFamilia: row.idFamilia,
        habilitado: Boolean(row.habilitado.data[0]),
      }))
    })
    .catch(err => err.response.data)
}

export const updateSpecieTableById = (data, token, specieId) => {
  return axios({
    method: 'put',
    url: `${BASE_URL}/${rt.SPECIE}/${rt.UPDATE_SPECIE}/${specieId}`,
    data,
    headers: {
      Authorization: token,
    },
  })
    .then(response => response.data)
    .catch(err => err.response.data)
}

export const createSpecie = (data, token) => {
  return axios({
    method: 'post',
    url: `${BASE_URL}/${rt.SPECIE}/${rt.REGISTER_SPECIE}`,
    data,
    headers: {
      Authorization: token,
    },
  })
    .then(response => response.data)
    .catch(err => err.response.data)
}

export const getParishAll = () => {
  return axios
    .get(`${BASE_URL}/${rt.PARISH}`)
    .then(res => createOptionList(res, 'id_pa', 'nombre'))
    .catch(err => err.response.data)
}

export const getCategoryAll = () => {
  return axios
    .get(`${BASE_URL}/${rt.CATEGORY}`)
    .then(res => Object.values(createOptionList(res, 'id_ctg', 'nombre')))
    .catch(err => err.response.data)
}

export const getCategoryTypeAll = () => {
  return axios
    .get(`${BASE_URL}/${rt.CATEGORY_TYPE}`)
    .then(res => res.data)
    .catch(err => err.response.data)
}

export const getMetaFeaturesAll = () => {
  return axios
    .get(`${BASE_URL}/${rt.META_FEATURE}`)
    .then(res => res.data)
    .catch(err => err.response.data)
}

export const getOptionsMetaFeaturesAll = () => {
  return getMetaFeaturesAll()
    .then(data => {
      const items = _.filter(data.res, obj => _.includes([11, 14, 15], obj.id_mc))
      return _.map(items, obj => {
        const optionsInside = _.split(obj.u_medida, ',')
        const purgeList = _.map(optionsInside, (v, i) => ({
          id: i + 1,
          title: _.trim(v),
        }))
        return {
          id: obj.key,
          title: obj.nombre,
          options: purgeList,
        }
      })
    })
    .catch(err => console.log('Error :>> ', err))
}

export const getCTByCategory = categoryID => {
  return axios
    .get(`${BASE_URL}/${rt.CATEGORY_TYPE}/category/${categoryID}`)
    .then(res =>
      res.data.res.map(obj => ({
        chip: true,
        category: categoryID,
        typecategory: obj.id_ctgT,
        name: obj.key,
        label: obj.descripcion,
        initvalue: '',
      }))
    )
    .catch(err => err.response.data)
}

export const disableInconveniences = (treeId, data, token) => {
  return axios({
    method: 'put',
    url: `${BASE_URL}/${rt.INCONVENIENCE}/${rt.DISABLE_INCONVENIENCE}/${treeId}`,
    data,
    headers: {
      Authorization: token,
    },
  })
    .then(response => response.data.res)
    .catch(error => error.response.data)
}

export const createFeaturesByKey = (treeId, data, token) => {
  return axios({
    method: 'post',
    url: `${BASE_URL}/${rt.FEATURE}/${rt.UPDATE_FEATURE}/${treeId}`,
    data,
    headers: {
      Authorization: token,
    },
  })
    .then(res => res.data.response)
    .catch(err => err.response.data.response)
}
export const createAFeature = (treeId, data, token) => {
  return axios({
    method: 'post',
    url: `${BASE_URL}/${rt.FEATURE}/${rt.CREATE_FEATURE}/${treeId}`,
    data,
    headers: {
      Authorization: token,
    },
  })
    .then(res => res.data.typeAction)
    .catch(err => err.response.data.typeAction)
}

export const createAndUpdateInconvenienceLog = (treeId, data, token) => {
  return axios({
    method: 'post',
    url: `${BASE_URL}/${rt.INCONVENIENCE}/${rt.UPDATE_INCONVENIENCE}/${treeId}`,
    data,
    headers: {
      Authorization: token,
    },
  })
    .then(response => response.data.res)
    .catch(error => error.response.data)
}

export const updateTreeTable = (treeId, data, token) => {
  return axios({
    method: 'put',
    url: `${BASE_URL}/${rt.TREE}/${rt.UPDATE_TREE}/${treeId}`,
    data,
    headers: {
      Authorization: token,
    },
  })
    .then(response => response.data.res)
    .catch(error => error.response.data)
}

export const createTreeTable = ({
  acronym,
  recorded,
  specieId,
  siteId,
  commit,
  treeVerified,
  alive,
  token,
}) => {
  return axios({
    method: 'post',
    url: `${BASE_URL}/${rt.TREE}/${rt.REGISTER_TREE}`,
    data: {
      acronym,
      recorded,
      specieId,
      siteId,
      commit,
      treeVerified,
      alive,
    },
    headers: {
      Authorization: token,
    },
  })
    .then(response => response.data)
    .catch(error => error.response.data)
}

export const getSpeciesByFamilyId = familyId => {
  return axios
    .get(`${BASE_URL}/${rt.SPECIE}/${rt.FAMILY_ALL}/${familyId}`)
    .then(response => response.data.res)
    .catch(error => error.response.data)
}

export const specieIncludedInFamily = (familyId, specieId) => {
  return axios({
    method: 'get',
    url: `${BASE_URL}/${rt.SPECIE}/${rt.VERIFIED_WITH_FAMILY}`,
    data: {
      familyId,
      specieId,
    },
  })
    .then(response => response.data.res)
    .catch(error => error.response.data)
}

export const getSiteNameAll = () => {
  return axios
    .get(`${BASE_URL}/${rt.SITE}`)
    .then(response => {
      const dataUnique = _.uniqBy(response.data.res, 'nombre')
      const listSiteName = _.map(dataUnique, 'nombre')
      return listSiteName
    })
    .catch(error => error.response.data)
}

export const getSiteAll = () => {
  return axios
    .get(`${BASE_URL}/${rt.SITE}`)
    .then(response => response.data?.res)
    .catch(error => error.response.data)
}

export const getOptionsSite = () => {
  return getSiteAll()
    .then(response => {
      const uniq = _.unionBy(response, 'nombre')
      const sorted = _.orderBy(uniq, ['nombre'], ['asc'])
      return (
        sorted?.map(o => ({
          title: o.nombre,
          id: o.id_s,
        })) ?? []
      )
    })
    .catch(error => error)
}

export const getPseudomynAll = () => {
  return axios
    .get(`${BASE_URL}/${rt.PSEUDONYM}`)
    .then(response => response.data?.pseudonym)
    .catch(error => error.response.data)
}

export const getOptionsPseudonym = () => {
  return getPseudomynAll()
    .then(response => {
      const uniq = _.unionBy(response, 'nombre_comun')
      const sorted = _.orderBy(uniq, ['nombre_comun'], ['asc'])
      return (
        sorted?.map(o => ({
          title: o.nombre_comun,
          id: o.id_ps,
        })) ?? []
      )
    })
    .catch(error => error)
}

export const getTreeAllFilterBy = ({ type, queryFilters }) => {
  return axios({
    method: 'post',
    url: `${BASE_URL}/${rt.TREE}/${rt.FILTERS}`,
    data: {
      type,
      queryFilters,
    },
  })
    .then(response => response.data?.res)
    .catch(error => error.response.data)
}

export const getSiteSectionAll = () => {
  return axios
    .get(`${BASE_URL}/${rt.SITE}`)
    .then(response => {
      const dataUnique = _.uniqBy(response.data.res, 'seccion')
      const listSeccionName = _.map(dataUnique, 'seccion')
      return listSeccionName
    })
    .catch(error => error.response.data)
}

export const createSiteTable = (
  { siteName, typeSite, section, parishId, siteAcronym },
  token
) => {
  return axios({
    method: 'post',
    url: `${BASE_URL}/${rt.SITE}/${rt.REGISTER_SITE}`,
    data: {
      sitio: siteName,
      seccion: section,
      tipoSitio: typeSite !== '#' ? typeSite : null,
      idParroquia: parishId !== '#' ? parishId : null,
      acronimoSitio: siteAcronym,
    },
    headers: {
      Authorization: token,
    },
  })
    .then(response => response.data.action)
    .catch(error => error.response.data)
}

export const createPseudonyms = (data, token) => {
  return axios({
    method: 'post',
    url: `${BASE_URL}/${rt.PSEUDONYM}/${rt.PSEUDONYM_BACTH}`,
    data: {
      data,
    },
    headers: {
      Authorization: token,
    },
  })
    .then(response => {
      return response.data.actions
    })
    .catch(error => error.response.data)
}

export const deletePseudonymsOfSpecie = (data, token) => {
  return axios({
    method: 'put',
    url: `${BASE_URL}/${rt.PSEUDONYM}/${rt.DELETE_PSEUDONYM}`,
    data: {
      data,
    },
    headers: {
      Authorization: token,
    },
  })
    .then(response => response.data.actions)
    .catch(error => error.response.data)
}

export const activePseudonymsOfSpecie = (data, token) => {
  return axios({
    method: 'put',
    url: `${BASE_URL}/${rt.PSEUDONYM}/${rt.ACTIVE_PSEUDONYM}`,
    data: {
      data,
    },
    headers: {
      Authorization: token,
    },
  })
    .then(response => response.data.actions)
    .catch(error => error.response.data)
}

export const getSiteAcronymAll = () => {
  return axios
    .get(`${BASE_URL}/${rt.SITE}`)
    .then(response => {
      const dataUnique = _.uniqBy(response.data.res, 'acronimoSitio')
      const orderby = _.orderBy(dataUnique, ['acronimoSitio'], ['asc'])
      return _.map(orderby, 'acronimoSitio')
    })
    .catch(error => error.response.data)
}

export const isUserVerify = token => {
  const config = {
    headers: { Authorization: token },
  }
  return axios
    .get(`${BASE_URL}/${rt.AUTH_VERIFY}`, config)
    .then(response => {
      return response.data
    })
    .catch(error => error.response.data)
}

export const getUserById = (id, token) => {
  return axios({
    method: 'get',
    url: `${BASE_URL}/${rt.APP_USER}/${id}`,
    headers: {
      Authorization: token,
    },
  })
    .then(response => response.data)
    .catch(error => error.response.data)
}

export const updateStatusTreeRegister = (treeId, data, token) => {
  return axios({
    method: 'put',
    url: `${BASE_URL}/${rt.TREE}/${rt.UPDATE_STATUS_REGISTER}/${treeId}`,
    data,
    headers: {
      Authorization: token,
    },
  })
    .then(response => response.data)
    .catch(error => error.response.data)
}

export const isVaidTree = treeId => {
  return axios({
    method: 'get',
    url: `${BASE_URL}/${rt.VALID_TREE}/${treeId}`,
  })
    .then(response => response.data)
    .catch(error => error.response.data)
}

export const getReportHeader = token => {
  const config = {
    headers: { Authorization: token },
  }
  return axios
    .get(`${BASE_URL}/report/headers`, config)
    .then(response => response.data)
    .catch(error => error.response.data)
}

export const getReportData = async token => {
  try {
    const config = {
      headers: { Authorization: token },
    }
    const response = await axios.get(`${BASE_URL}/report/data`, config)
    return response.data
  } catch (error) {
    throw new Error(error.error)
  }
}

export const verifyEmail = email => {
  return axios({
    method: 'post',
    url: `${BASE_URL}/${rt.AUTH_VERIFY_USER}`,
    data: { email },
  })
    .then(response => response.data)
    .catch(error => error.response.data)
}

export const getUserMe = token => {
  return axios({
    method: 'get',
    url: `${BASE_URL}/${rt.APP_USER}/me`,
    headers: {
      Authorization: token,
    },
  })
    .then(response => response.data)
    .catch(error => error.response.data)
}

export const updateUser = (data, token) => {
  return axios({
    method: 'put',
    url: `${BASE_URL}/${rt.APP_USER}/${rt.UPDATE_ACCOUNT}`,
    data,
    headers: {
      Authorization: token,
    },
  })
    .then(response => response.data)
    .catch(error => error.response.data)
}

export const updateUserById = (data, token, userId) => {
  return axios({
    method: 'put',
    url: `${BASE_URL}/${rt.APP_USER}/${userId}`,
    data,
    headers: {
      Authorization: token,
    },
  })
    .then(response => response.data)
    .catch(error => error.response.data)
}

export const getUserAll = token => {
  return axios({
    method: 'get',
    url: `${BASE_URL}/${rt.APP_USER}`,
    headers: {
      Authorization: token,
    },
  })
    .then(response => {
      return getRole(token)
        .then(role => {
          let res = []
          if (response.data?.auth) {
            res = _.map(response.data.users, user => {
              const filterRol = _.filter(role?.roles, ['id_r', user.idRol])
              return {
                id: user.id_u,
                nombre: user.nombre,
                apellido: user.apellido,
                email: user.email,
                habilitado: Boolean(user.habilitado.data[0]),
                fecha_registro: moment(user.fecha_registro).utc().format('LL'),
                fecha_actualizo: moment(user.fecha_actualizo).utc().format('LL'),
                idGrupoMedicion: user.idGrupoMedicion ?? '-',
                idRol: filterRol?.[0]?.tipo ?? user.idRol,
              }
            })
          }
          return res
        })
        .catch(error => console.log('Error', error.response.data))
    })
    .catch(error => console.log('Error', error.response.data))
}

export const createUser = data => {
  return axios({
    method: 'post',
    url: `${BASE_URL}/${rt.APP_USER}/${rt.REGISTER_USER}`,
    data,
  })
    .then(response => response.data)
    .catch(error => error.response.data)
}

export const sendEmailResetPassword = email => {
  return axios({
    method: 'post',
    url: `${BASE_URL}/${rt.AUTH_SEND_EMAIL_RESET_PASSWORD}`,
    data: { email },
  })
    .then(response => response.data)
    .catch(error => error.response.data)
}

export const approveUserAccount = (data, token) => {
  return axios({
    method: 'put',
    url: `${BASE_URL}/${rt.AUTH_APPROVE_USER_ACCOUNT}`,
    data,
    headers: {
      Authorization: token,
    },
  })
    .then(response => response.data)
    .catch(error => error.response.data)
}

export const resetPassword = (data, token) => {
  return axios({
    method: 'put',
    url: `${BASE_URL}/${rt.APP_USER}/${rt.UPDATE_PASSWORD}`,
    data,
    headers: {
      Authorization: token,
    },
  })
    .then(response => response.data)
    .catch(error => {
      console.log('error.response.data :>> ', error.response.data)
      return error.response.data
    })
}

export const getMeasuringGroup = () => {
  return axios({
    method: 'get',
    url: `${BASE_URL}/${rt.WORK_GROUP}`,
  })
    .then(response => response.data)
    .catch(error => error.response.data)
}

export const createMeasuringGroup = (data, token) => {
  return axios({
    method: 'post',
    url: `${BASE_URL}/${rt.WORK_GROUP}`,
    data,
    headers: {
      Authorization: token,
    },
  })
    .then(response => response.data)
    .catch(error => error.response.data)
}

export const getRole = token => {
  return axios({
    method: 'get',
    url: `${BASE_URL}/${rt.ROLE}`,
    headers: {
      Authorization: token,
    },
  })
    .then(response => response.data)
    .catch(error => error.response.data)
}

export const getReportHeaderPublic = () => {
  return axios
    .get(`${BASE_URL}/public-reports/headers`)
    .then(response => response.data)
    .catch(error => error.response.data)
}

export const getReportDataPublic = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/public-reports/data`)
    return response.data
  } catch (error) {
    throw new Error(error.error)
  }
}

export const getTreeRegisterCount = () => {
  return axios
    .get(`${BASE_URL}/public-reports/countTree`)
    .then(response => response.data.count)
    .catch(error => error.response.data)
}

export const getAdvancedSearch = filtersList => {
  return axios({
    method: 'post',
    url: `${BASE_URL}/${rt.TREE}/${rt.GEOJSON_FILTERS_ADVANCED}`,
    data: { filtersList },
  })
    .then(res => ({
      type: 'FeatureCollection',
      features: res.data.response || [],
    }))
    .catch(error => {
      console.log('Error :>> ', error.response.data)
      return {}
    })
}

export const getOptionsCodes = () => {
  return axios
    .get(`${BASE_URL}/${rt.TREE}/${rt.ALL_ENABLE_TREE_CODES}`)
    .then(response => {
      const sorted = _.orderBy(response?.data?.codes, ['codigo'], ['asc'])
      return sorted?.map((o, i) => ({ id: i, title: o.codigo })) ?? []
    })
    .catch(error => error)
}

export const getOptionsCategoryAll = categoryID => {
  return axios({
    method: 'get',
    url: `${BASE_URL}/${rt.CATEGORY_TYPE}/category/${categoryID}`,
  })
    .then(response => {
      const data = response?.data?.res
      _.remove(data, obj => _.includes([32, 86, 87, 88, 89, 90, 91, 92], obj.id_ctgT))
      const uniqKeyList = _.uniq(_.map(data, 'key'))
      return _.map(uniqKeyList, key => {
        const filtered = _.filter(data, ['key', key])
        const options = _.map(filtered, (o, i) => ({ id: i + 1, title: o.enum }))
        return { id: filtered[0].key, title: filtered[0].descripcion, options }
      })
    })
    .catch(error => {
      console.log('Error :>> ', error.response.data)
      return {}
    })
}

export const updateDownloadCounter = () => {
  return axios({
    method: 'post',
    url: `${BASE_URL}/${rt.UPDATE_DOWNLOAD_COUNTER}`,
  })
    .then(res => res?.data?.update || false)
    .catch(error => {
      console.log('Error :>> ', error.response.data)
      return false
    })
}

export const getDownloadCounter = () => {
  return axios({
    method: 'get',
    url: `${BASE_URL}/${rt.PROJECT}`,
  })
    .then(res => res?.data?.res?.[0]?.descargaDB ?? 0)
    .catch(error => {
      console.log('Error :>> ', error?.response?.data)
      return 0
    })
}
